export const getMaskedText = (textLength: number) => {
  return '•'.repeat(textLength)
}

export const truncateId = (
  id: string | undefined | null,
  prefixLength = 8,
  suffixLength = 7,
  fallback = '-'
): string => {
  if (!id) return fallback
  if (id.length <= prefixLength + suffixLength) return id
  return `${id.slice(0, prefixLength)}...${id.slice(-suffixLength)}`
}
